import getRouterBasename from '@/lib/router';
import App from 'App';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  ChainlitContext, // RAGBOT
  useApi,
  useAuth,
  useChatInteract,
  useConfig
} from '@chainlit/react-client';

// RAGBOT
export const LoginError = new Error(
  'Error logging in. Please try again later.'
);

export default function AppWrapper() {
  const [translationLoaded, setTranslationLoaded] = useState(false);
  const { data: config, isAuthenticated, isReady, setUserFromAPI } = useAuth(); // RAGBOT
  const { language: languageInUse } = useConfig();
  const { i18n } = useTranslation();
  const { windowMessage } = useChatInteract();
  const apiClient = useContext(ChainlitContext); // RAGBOT

  function handleChangeLanguage(languageBundle: any): void {
    i18n.addResourceBundle(languageInUse, 'translation', languageBundle);
    i18n.changeLanguage(languageInUse);
  }

  const { data: translations } = useApi<any>(
    `/project/translations?language=${languageInUse}`
  );

  useEffect(() => {
    if (!translations) return;
    handleChangeLanguage(translations.translation);
    setTranslationLoaded(true);
  }, [translations]);

  useEffect(() => {
    const handleWindowMessage = (event: MessageEvent) => {
      windowMessage(event.data);
    };
    window.addEventListener('message', handleWindowMessage);
    return () => window.removeEventListener('message', handleWindowMessage);
  }, [windowMessage]);

  if (!translationLoaded) return null;

  // RAGBOT: when header auth is enabled, log the user in
  const handleCookieAuth = (json: any): void => {
    if (json?.success != true) throw LoginError;

    // Validate login cookie and get user data.
    setUserFromAPI();
  };

  // RAGBOT
  const handleAuth = async (jsonPromise: Promise<any>) => {
    try {
      const json = await jsonPromise;

      handleCookieAuth(json);
    } catch (error: any) {
      // Header auth failed; the login page handles reporting the error.
    }
  };

  // RAGBOT
  const handleHeaderAuth = async () => {
    const jsonPromise = apiClient.headerAuth();
    handleAuth(jsonPromise);
  };

  if (
    isReady &&
    !isAuthenticated &&
    window.location.pathname !== getRouterBasename() + '/login' &&
    window.location.pathname !== getRouterBasename() + '/login/callback'
  ) {
    if (config?.headerAuth) { // RAGBOT
      handleHeaderAuth();
    } else window.location.href = getRouterBasename() + '/login';
  }
  return <App />;
}
